import React, { useEffect, useState } from "react";
import Select from "react-select";
import httpRequest from "../../../utils/Http";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UpdateSFCallTyeMapping = ({ sfdetails, roleId }) => {
  const [applianceData, setApplianceData] = useState([]);
  const [allCallTypeGroup, setCallTypeGroup] = useState({});
  const [formData, setFormData] = useState({});
  const [isSubmit, setSubmit] = useState(false);

const setselecteddata = (val, item, index) => {
  const updatedFormData = [...formData]; // Create a copy

  if (!val || val.length === 0) {
    updatedFormData[index].calltype_group = [];
  } else {
    const isSelectAllClicked = val.some((opt) => opt.value === "select_all");

    if (isSelectAllClicked) {
      // Select all except "Select All"
      const allOptions = allCallTypeGroup.filter(opt => opt.value !== "select_all");
      updatedFormData[index].calltype_group = allOptions;
    } else {
      updatedFormData[index].calltype_group = val;
    }
  }

  setFormData(updatedFormData); // Update the state with new copy
};


  useEffect(() => {
    (async () => {
      const listdata = await httpRequest(
        "getsfcalltypemappinglistview?sf_id=" + sfdetails.id,
        {},
        "GET"
      );
      if (listdata.status === true && listdata.data) {
        setApplianceData(listdata.data);
        setFormData(listdata.data);
      }

      const listdata2 = await httpRequest("getcalltypegrouplist", {}, "GET");
      if (listdata2.status === true && listdata2.data) {
         const callTypeList = listdata2.data?.rows;
         const options = [
            { label: "Select All", value: "select_all" },
            ...callTypeList.map((item) => ({
              label: item.label,
              value: item.value,
            })),
          ];
        setCallTypeGroup(options);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (isSubmit) {
        let formData1 = new FormData();
        formData1.append("formdata", JSON.stringify(formData));

        const data = await httpRequest(
          "updatecalltypedata?sf_id=" + sfdetails.id,
          formData,
          "POST"
        );
        if (data.status === true && data.message) {
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
        setSubmit(false);
      }
    })();
  }, [isSubmit]);

  const onSubmitHandler = (event) => {
    event.preventDefault();
    setSubmit(true);
  };


  return (
    <>
      <section className="content">
        <div className="container-fluid">
          <div className="card card-default">
            <div className="card-header">
              <h3 className="card-title">Update Call Type Mapping</h3>
            </div>
            <form id="calltypeeditor" onSubmit={onSubmitHandler}>
              <div className="card-body">
                <div className="row">
                  {applianceData.map((item, index) => (
                    <div key={"colsm-" + index} className="col-12 col-sm-6">
                      <div key={"formgroup-" + index} className="form-group">
                        <label key={"label-" + index}>
                          {item.appliance_name}

                          {/* {item.calltype_group.length > 0 && (
                                                        setFormData({ ...formData, calltype_group: item.calltype_group });
                                                    )} */}
                        </label>
                        <input
                          type="hidden"
                          name="appliance_id"
                          value={item.appliance_id}
                        />
                       <Select
                          defaultValue={item.calltype_group}
                          key={index}
                          isMulti={true}
                          name="calltype_group_id"
                          options={allCallTypeGroup}
                          value={formData[index]?.calltype_group}
                          onChange={(val) => {
                            setselecteddata(val, item, index);
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                
                  <div className="card-footer">
                    <div className="row">
                      <input
                        type="submit"
                        className="form-control btn btn-primary"
                        value={"Submit"}
                      />
                    </div>
                  </div>
              
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default UpdateSFCallTyeMapping;
